var BASE_URL = process.env.API_ROOT + "/v2";

export default {
    FETCH_POLICY: BASE_URL + "/notice/policies/${policyId}",
    FETCH_CATEGORIES: BASE_URL + "/notice/policies/categories",
    FETCH_ANNOUNCEMENT: BASE_URL + "/notice/announcements/${announcementId}",
    FORCE_CARD_CREATED: BASE_URL + "/force-create-card"
}


// WEBPACK FOOTER //
// ./src/Config.js